import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserRepository } from 'repositories/UserRepository';
import { IAuthState } from 'store/slices/authSlice';
import { IUserPayoutState } from 'store/slices/userPayoutSlice';
import { IPayout, TPayoutQuery } from 'types';
import { IApiResponseDetails } from 'types/api';

export const fetchPayoutsList = createAsyncThunk<
  { content: IPayout[]; details: IApiResponseDetails },
  void,
  { state: { auth: IAuthState; userPayouts: IUserPayoutState } }
>('userPayouts/fetchPayoutsList', async (_, { getState }) => {
  const {
    auth: { token },
    userPayouts: {
      currentPage,
      itemsPerPage,
      filterByConfirmationStatus,
      search,
      sortBy,
      sortDir,
      fromDate,
      toDate,
    },
  } = getState();

  if (!token) throw Error('no token');

  const params: TPayoutQuery = { page: String(currentPage), size: String(itemsPerPage) };
  if (filterByConfirmationStatus) params.status = filterByConfirmationStatus;
  if (search) params.filter = search;
  if (sortBy) {
    params.sort = sortDir ? `payments.${sortBy},${sortDir.toLowerCase()}` : sortBy;
  }
  if (fromDate) params.from = fromDate;
  if (toDate) params.to = toDate;
  const payoutsListResponse = await UserRepository.getPayouts(token, params);

  if (payoutsListResponse.status === 'failed') throw Error(payoutsListResponse.error);

  return payoutsListResponse.data;
});

export const fetchExportPayouts = createAsyncThunk<
  { exportData: string },
  void,
  { state: { auth: IAuthState } }
>('userAccruals/fetchExportPayouts', async (_, { getState }) => {
  const {
    auth: { token },
  } = getState();

  if (!token) throw Error('no token');

  const exportPayoutsResponse = await UserRepository.getExportPayouts(token);

  if (exportPayoutsResponse.status === 'failed') throw Error(exportPayoutsResponse.error);

  return {
    exportData: exportPayoutsResponse.data,
  };
});
